import { useStoreActions, useStoreState } from "../hooks/ep";
import { useAsync } from "react-use";

export function useEnsureOpportunitiesData() {
  return useEnsureFactory("opportunities");
}

export function useEnsureFlopptionsData() {
  return useEnsureFactory("flopptions");
}

export function useEnsureTripNotesData() {
  return useEnsureFactory("tripNotes");
}

export function useEnsureDeadOppsData() {
  return useEnsureFactory("dead_opps");
}

export function useEnsureDeadFlopptionsData() {
  return useEnsureFactory("dead_flopptions");
}

export function useEnsureActionReportsData() {
  return useEnsureFactory("actionReports");
}

export function useEnsureFactory(sliceName) {
  const initialDataReceived = useStoreState(
    (s) => s[sliceName].initialDataReceived,
    [sliceName]
  );

  // noinspection JSUnresolvedVariable
  const handle = useStoreActions(
    (a) => a[sliceName].maybeHandleFetchInitialData,
    [sliceName]
  );
  return useAsync(handle, [initialDataReceived, sliceName]).loading;
}
